/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {KIND} from 'baseui/notification'
import forOwn from 'lodash/forOwn'
import isString from 'lodash/isString'
import equals from 'validator/lib/equals'
import isAscii from 'validator/lib/isAscii'
import isEmail from 'validator/lib/isEmail'
import isLength from 'validator/lib/isLength'

const errors = {
  email: {
    code: 'email',
    message: 'Provided email is not valid.',
    kind: KIND.warning,
  },
  passwordLength: {
    code: 'password',
    message: 'Password must be at least 6 characters long.',
    kind: KIND.warning,
  },
  passwordAscii: {
    code: 'password',
    message: 'Only ASCII characters are allowed.',
    kind: KIND.warning,
  },
  passwordMatching: {
    code: 'confirmation',
    message: 'Passwords do not match.',
    kind: KIND.warning,
  },
}

export const trimFieldStringValues = obj => {
  let trimmedValues = {}

  forOwn(obj, (val, key) => {
    isString(val) ? (trimmedValues[key] = val.trim()) : (trimmedValues[key] = val)
  })

  return trimmedValues
}

export const isValidEmail = (email = '') => {
  if (!isEmail(email)) {
    return errors.email
  }

  return null
}

export const isValidPassword = (password = '') => {
  if (!isLength(password, {min: 6, max: undefined})) {
    return errors.passwordLength
  }

  if (!isAscii(password)) {
    return errors.passwordAscii
  }

  return null
}

export const isMatch = (stringA = '', stringB = '') => {
  if (!equals(stringA, stringB)) {
    return errors.passwordMatching
  }

  return null
}

export const validateCredentials = credentials => {
  const {email, password, confirmation} = credentials

  const invalidEmail = isValidEmail(email)
  if (invalidEmail) {
    return invalidEmail
  }

  const invalidPassword = isValidPassword(password)
  if (invalidPassword) {
    return invalidPassword
  }

  if (isString(confirmation)) {
    const passwordsNotMatching = isMatch(password, confirmation)
    if (passwordsNotMatching) {
      return passwordsNotMatching
    }
  }

  return null
}

export const validatePasswordMatching = credentials => {
  const {password, confirmation} = credentials

  const invalidPassword = isValidPassword(password)
  if (invalidPassword) {
    return invalidPassword
  }

  const passwordsNotMatching = isMatch(password, confirmation)
  if (passwordsNotMatching) {
    return passwordsNotMatching
  }

  return null
}
